import { message } from "antd";

export const imageExtensions = ["JPG", "JPEG", "PNG"];
export const allowedFileTypes = [
  "jpeg",
  "png",
  "jpg",
  "pdf",
  "doc",
  "ppt",
  "xls",
  "docx",
  "pptx",
  "xlsx",
  "csv",
  "ods",
  "txt",
  "msg",
  "eml"
];

export const allowedFileVideoTypes = [
  "jpeg",
  "png",
  "jpg",
  "pdf",
  "doc",
  "ppt",
  "xls",
  "docx",
  "pptx",
  "xlsx",
  "csv",
  "ods",
  "txt",
  "msg",
  "eml",
  "mp4",
  "mp3",
  "webm",
  "aac",
  "mov"
];

export const imageMaxSize = 20; // MB

export const fileMaxSize = 100; // MB

export const getFileExtension = (fileName) => {
  if (fileName) {
    return fileName.toUpperCase().split(".").pop();
  }
  return null;
};

export const validateImage = (file, t) => {
  if (!imageExtensions.includes(getFileExtension(file.name))) {
    message.error(t("container.form_errors.allowedFileTypes", { value: imageExtensions.join(", ") }));
    return false;
  }
  if (file.size / 1024 / 1024 > imageMaxSize) {
    message.error(t("container.form_errors.uploadMaxLimit", { value: imageMaxSize }));
    return false;
  }
  return true;
};

const getDefaultAllowedExtensions = (withVideoExtensions) =>
  withVideoExtensions ? allowedFileVideoTypes : allowedFileTypes;

export const validateFile = (file, t, extensions = [], withVideoExtensions = false) => {
  const fileExtension = getFileExtension(file.name);
  const allowedExtensions = extensions.length === 0 ? getDefaultAllowedExtensions(withVideoExtensions) : extensions;
  if (!allowedExtensions.includes(fileExtension) && !allowedExtensions.includes(fileExtension.toLowerCase())) {
    message.error(t("container.form_errors.allowedFileTypes", { value: allowedExtensions.join(", ") }));
    return false;
  }

  if (file.size / 1024 / 1024 > fileMaxSize) {
    message.error(t("container.form_errors.uploadMaxLimit", { value: fileMaxSize }));
    return false;
  }

  return true;
};
